/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgExcelLogo = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.336 1a.666.666 0 0 1 .664.664v12.672a.666.666 0 0 1-.664.664H4.664A.666.666 0 0 1 4 14.336V12H.664a.639.639 0 0 1-.469-.2.64.64 0 0 1-.195-.464V4.664A.64.64 0 0 1 .2 4.2.639.639 0 0 1 .664 4H4V1.664A.666.666 0 0 1 4.664 1ZM4 8.852l.945 1.773h1.43L4.789 8.047l1.555-2.531H4.977L4.1 7.117a.212.212 0 0 0-.028.051l-.027.059q-.211-.431-.43-.856t-.435-.855H1.727l1.515 2.546-1.656 2.563h1.437ZM9.5 4V2H5v2Zm0 10v-2H5v2Zm0-6.5V5H8v2.5Zm0 3.5V8.5H8V11ZM15 4V2h-4.5v2Zm0 3.5V5h-4.5v2.5Zm0 3.5V8.5h-4.5V11Zm0 3v-2h-4.5v2Z",
        fill: "#217346"
    }));
export default SvgExcelLogo;
